<template>
  <div id="page-ver-scroll-box">
    <div class="scrollBox">
      <div class="wrapper" ref="wrapper">
        <div class="content" ref="wrapper-content">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BetterScroll from "better-scroll";
export default {
  name: "scroll-box-view",
  props: ["width", "ready"],
  watch: {
    ready(n) {
      if (n) {
        this.init();
      }
    }
  },
  methods: {
    init() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs["wrapper-content"].style.width = this.width + "px";
          this.scroll = new BetterScroll(this.$refs.wrapper, {
            startX: 0,
            click: true,
            scrollX: true,
            scrollY: false,
            eventPassthrough: "vertical"
          });
        }, 0);
      });
    }
  },
  mounted() {
    if (this.ready) {
      this.init();
    }
  }
};
</script>
<style lang="less" scoped>
#page-ver-scroll-box {
  width: 100%;
  height: 100%;
  & > .scrollBox {
    width: 100%;
    height: 100%;
    overflow: hidden;
    z-index: 10;
    .wrapper {
      width: 100%;
      height: 100%;
    }
    .content {
      height: 100%;
    }
  }
}
</style>